import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  connect() {
    this.instances = new Map()
    this.initializeWithin(this.element)

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.removedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) this.destroyWithin(node)
        })
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) this.initializeWithin(node)
        })
      })
    })
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
    this.instances?.forEach((instance) => instance.destroy())
    this.instances?.clear()
  }

  initializeWithin(root) {
    if (root.matches?.(this.selector)) this.initializeField(root)
    root.querySelectorAll?.(this.selector).forEach((field) => this.initializeField(field))
  }

  initializeField(field) {
    if (field._flatpickr || this.instances.has(field)) return
    if (field.dataset.adminCalendarNative === "true") return
    if (field.dataset.controller?.split(/\s+/).includes("admin-datepicker")) return

    const dateTime = field.type === "datetime-local"
    const timeOnly = field.type === "time"
    const visibleClasses = field.className.split(/\s+/).filter((className) => className && className !== "is-hidden")
    const instance = flatpickr(field, {
      allowInput: true,
      altInput: true,
      altInputClass: ["admin-flatpickr-input", ...visibleClasses].join(" "),
      altFormat: field.dataset.adminCalendarAltFormat || (dateTime ? "M j, Y · h:i K" : timeOnly ? "h:i K" : "M j, Y"),
      dateFormat: dateTime ? "Y-m-d\\TH:i" : timeOnly ? "H:i" : "Y-m-d",
      disableMobile: true,
      enableTime: dateTime || timeOnly,
      noCalendar: timeOnly,
      time_24hr: false,
      locale: { firstDayOfWeek: 1 },
      minDate: field.min || undefined,
      maxDate: field.max || undefined
    })

    if (field.dataset.adminPartyProfileTarget && instance.altInput) {
      instance.altInput.dataset.adminPartyProfileTarget = field.dataset.adminPartyProfileTarget
      instance.altInput.classList.toggle("is-hidden", field.classList.contains("is-hidden"))
    }

    this.instances.set(field, instance)
  }

  destroyWithin(root) {
    this.instances.forEach((instance, field) => {
      if (field === root || root.contains(field)) {
        instance.destroy()
        this.instances.delete(field)
      }
    })
  }

  get selector() {
    return 'input[type="date"], input[type="datetime-local"], input[type="time"]'
  }
}
